// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"40":"807aeb6e","147":"ae6dcd8c","190":"820f93e2","561":"ec865d7f","981":"a8763264"}[chunkId] + ".css";
};